<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Add Vehicle Category'">
        <form v-on:submit.prevent="doSubmitCategory">
            <label>Name *</label>
            <b-form-input :required="true" for-input="name" type="text" name="name" id="name" label="Name" placeholder="Enter name" v-validate="categoryValidations.name" :error="errors.first('name')" v-model="category.name" data-vv-as="name"/><br>
            <label>Note *</label>
            <b-form-input :required="true" for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter note" v-validate="categoryValidations.note" :error="errors.first('note')" v-model="category.note" data-vv-as="note"/><br>
            <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.category.uuid !== null ? 'Update' : 'Submit'}} </b-button>
            <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        </form>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  
  export default {
    data () {
      return {
        apiUrl: {
          category: window.AppConfig.apiUrl + 'vehicle-category',
        },
        type: null,
        category: {
          uuid: null,
          name: null,
          exchangeId: null
        },
        categoryValidations: {
          name: {
              required: true
          },
          exchangeId: {
              required: true
          }
        }
      }
    },
    methods: {
      doSubmitCategory() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            if (this.category.uuid !== null) {
              let category = {}
              Object.keys(this.category).forEach(element => {
                  if (element !== 'uuid') {
                  category[element] = this.category[element]
                  }
              })
              this.$http.patch(this.apiUrl.category + '/' + this.category.uuid, category).then(response => {
                  this.isLoading = false
                  this.$store.dispatch('notification/success', 'Category successfully updated.')
                  this.$emit('getCategory')
                  this.resetData()
                  this.hideModal()
              }).catch(error => {
                  this.isLoading = false
                  this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl.category, this.category).then(response => {
                  this.isLoading = false
                  this.$store.dispatch('notification/success', 'Category successfully added.')
                  this.hideModal()
                  this.resetData()
                  this.$emit('getCategory')
              }).catch(error => {
                  this.isLoading = false
                  this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
          this.category.uuid = null
          this.category.name = null
          this.category.exchangeId = null
          this.$validator.reset()
      },
      showModal() {
          this.category.name = null
          this.category.exchangeId = null
          this.category.uuid = null
          this.$validator.reset();
          this.$refs['my-modal'].show()
      },
      hideModal () {
          this.resetData()
          this.$refs['my-modal'].hide()
      }
    }
  }
</script>